var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#D2F34C",
    stroke: "#D2F34C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2578 28.5472L49.3071 35.8594C49.5254 36.0342 49.5626 36.3551 49.3923 36.5787L38.6641 50.5577C37.9897 51.4212 36.9959 51.9098 35.931 51.9278L30.0745 52C29.7621 52.0035 29.4888 51.7872 29.4178 51.4771L28.0868 45.6901C27.8561 44.6264 28.0868 43.5267 28.7612 42.6794L39.5426 28.6337C39.7165 28.4083 40.0377 28.3687 40.2578 28.5472Z",
    fill: "#244034"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M53.3575 31.5014L51.613 33.6792C51.4373 33.9009 51.1214 33.937 50.9031 33.7603C48.7823 32.044 43.3517 27.6398 41.8449 26.4192C41.6249 26.239 41.5947 25.9181 41.7722 25.6945L43.4546 23.6051C44.9809 21.64 47.6429 21.4597 49.7903 23.1724L52.2572 25.1374C53.2688 25.9307 53.9432 26.9763 54.1739 28.076C54.4401 29.2857 54.1561 30.4738 53.3575 31.5014Z",
    fill: "#244034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyIcon);
export default __webpack_public_path__ + "static/media/ApplyIcon.6e5c707df8660dbd501faecb28c668ee.svg";
export { ForwardRef as ReactComponent };